/**
 * WhatsApp do suporte/comercial da HostVSL.
 * Fonte única: é o mesmo canal usado no menu de ajuda e no menu de conta.
 */
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/557199407090';

/**
 * Normaliza número de telefone para formato WhatsApp
 * Aceita: 71999998888, (71) 99999-8888, +55 71 99999-8888, etc.
 * Retorna: 5571999998888
 */
export function normalizeWhatsAppNumber(input: string): string {
  // Remove tudo que não for número
  let cleaned = input.replace(/\D/g, '');
  
  // Se começar com 0, remove
  if (cleaned.startsWith('0')) {
    cleaned = cleaned.slice(1);
  }
  
  // Se tiver 10 ou 11 dígitos (BR sem código país), adiciona 55
  if (cleaned.length >= 10 && cleaned.length <= 11 && !cleaned.startsWith('55')) {
    cleaned = '55' + cleaned;
  }
  
  return cleaned;
}

/**
 * Gera link do WhatsApp com número normalizado e mensagem opcional
 */
export function generateWhatsAppLink(number: string, message?: string): string {
  const normalizedNumber = normalizeWhatsAppNumber(number);
  const baseUrl = `https://wa.me/${normalizedNumber}`;
  
  if (message && message.trim()) {
    return `${baseUrl}?text=${encodeURIComponent(message)}`;
  }
  
  return baseUrl;
}
